import { Component, OnInit } from '@angular/core';
import { AuthControllerService } from '../Services/auth-controller.service';
import { PlaceService } from '../Services/place.service';
import { MyModalService } from '../Services/modal-service.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-place',
  templateUrl: './place.component.html',
  styleUrls: ['./place.component.css']
})
export class PlaceComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;

  place_name: string;
  place_type: string;
  placelist: any = [];
  view_placelist: any = [];
  selectplace: any;
  type_list = [
    {value: "1", text: "営業所／事務所"},
    {value: "2", text: "展示場"},
    {value: "3", text: "ご自宅"},
    {value: "4", text: "ご自宅／建築地"},
    {value: "5", text: "建築地"},
    {value: "9", text: "その他"},
  ]
  message: string;
  error_message: string;
  viewSold = false;

  constructor(
    private AuthControll: AuthControllerService,
    private placeService: PlaceService,
    private modal: MyModalService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.getPlaceList();
  }

  getPlaceList() {
    this.placeService.list().subscribe(result => {
      this.placelist = result;
      this.resetOrder();
      this.filterPlaceList();
    });
  }
  //保存
  save() {
    this.message = '';
    this.error_message = '';
    this.placeService.update(this.placelist).subscribe(res => {
      if (('error' in res) && res['error'] == 1) {
        this.error_message = '面談場所の保存に失敗しました。';
      } else {
        this.message = '面談場所を保存しました。';
      }
      this.getPlaceList();
    });
  }

  //登録
  add() {
    let places = this.placelist.filter(place=>{
      return !place.sold;
    });
    let sort = '1' + ('00' + places.length).slice(-3);
    if (this.place_name != undefined && this.place_name != '') {
      var temp = {
        place_id: null,
        place_name: this.place_name,
        place_order: sort,
        place_type: this.place_type,
        sold: 0
      };
      this.placeService.update([temp]).subscribe(res => {
        if (('error' in res) && res['error'] == 1) {
          this.error_message = '面談場所の保存に失敗しました。';
        } else {
          this.message = '面談場所を保存しました。';
          this.getPlaceList();
        }
      })
    }
  }

  // 削除
  async delete(selectplace) {
    if (selectplace > 0) {
      let selectdata = this.placelist.filter(place => {
        return (place.place_id == selectplace);
      });
      if (selectdata.length > 0 && selectdata[0].place_id) {
        const res = await this.modal.confirm('削除', '『' + selectdata[0].place_name + '』を本当に削除してもよろしいですか？');
        if (!res) {
          return;
        }
        this.placeService.delete(selectdata[0].place_id).subscribe(res => {
          if (('error' in res) && res['error'] == 1) {
            this.error_message = '面談場所の削除に失敗しました。';
          } else {
            this.getPlaceList();
          }
        });
      }
    }
  }

  //リストボックス操作
  prev(selectplace) {
    /*
    if (this.selectplace > 0) {
      let index = this.placelist.findIndex(i => i.place_id == this.selectplace);
      if (index > 0) {
        this.placelist[index - 1].place_order++;
        this.placelist[index].place_order--;
      }
      this.resetOrder();
    }
    */
    if (selectplace > 0) {
      let index = this.placelist.findIndex(i => i.place_id == selectplace);
      if (index > 0) {
        this.placelist[index - 1].place_order++;
        this.placelist[index].place_order--;
      }
      this.resetOrder();
      this.filterPlaceList()
    }
  }

  next(selectplace) {
    if (selectplace > 0) {
      let index = this.placelist.findIndex(i => i.place_id == selectplace);
      if (index < (this.placelist.length - 1)) {
        this.placelist[index].place_order++;
        this.placelist[index + 1].place_order--;
      }
      this.resetOrder();
      this.filterPlaceList()
    }
  }

  resetOrder() {
    this.placelist.sort((val1, val2) => {
      if (val1.place_order < val2.place_order) return -1;
      if (val1.place_order > val2.place_order) return 1;
      return 0;
    });
    let order = 1;
    let soldOrder = 10001;
    this.placelist.forEach((val, idx) => {
      if (val.sold) {
        val.place_order = soldOrder++;
      } else {
        val.place_order = order++;
      }
    });
    // 再ソート
    this.placelist.sort((val1, val2) => {
      if (val1.place_order < val2.place_order) return -1;
      if (val1.place_order > val2.place_order) return 1;
      return 0;
    });
  }
  getTypeName(val) {
    let typeinfo = this.type_list.filter(type=>{
      return !!(type.value == val)
    })
    if (typeinfo.length > 0) {
      return typeinfo[0].text;
    }
    return '';
  }
  filterPlaceList() {
    if (this.viewSold) {
      this.view_placelist = this.placelist.slice();
    } else {
      this.view_placelist = this.placelist.filter(place=>{
        return !place.sold;
      });
    }
  }
}
